import { useTranslation } from 'react-i18next'
import { Span, Text } from '@/components/atoms'
import { useSignaturePad } from './signature-pad.hook'

interface SignaturePadProps {
  label?: string
  error?: string
  onChange?: (dataUrl: string | undefined) => void
  className?: string
}

export function SignaturePad({
  label,
  error,
  onChange,
  className = '',
}: SignaturePadProps) {
  const { t } = useTranslation()
  const {
    canvasRef,
    hasSignature,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handleClear,
  } = useSignaturePad({ onChange })

  return (
    <div className={`flex w-full flex-col gap-3 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        {label && <Text className="text-neutral-900">{label}</Text>}
        <button
          type="button"
          onClick={handleClear}
          disabled={!hasSignature}
          className="text-indigo-base tracking-base ml-auto text-xs disabled:text-neutral-300"
        >
          {t('common.signaturePad.clear')}
        </button>
      </div>

      <div
        className={`relative h-40 w-full overflow-hidden rounded-2xl border border-dashed bg-(--file-upload-bg) ${error ? 'border-error-base' : 'border-neutral-300'}`}
      >
        {!hasSignature && (
          <Span className="pointer-events-none absolute inset-0 flex items-center justify-center text-neutral-300">
            {t('common.signaturePad.placeholder')}
          </Span>
        )}
        <canvas
          ref={canvasRef}
          className="absolute inset-0 size-full touch-none"
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          onPointerLeave={handlePointerUp}
        />
      </div>

      {error && <Span className="text-error-base">{error}</Span>}
    </div>
  )
}
